import type { JSX } from 'react';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { DescriptionWrapper } from './components/DescriptionWrapper';

async function loadDescriptionStep(): Promise<typeof DescriptionWrapper> {
	return (
		await import(/* webpackChunkName: "pages/start-a-petition-steps-description" */ './components/DescriptionWrapper')
	).DescriptionWrapper;
}

export function DescriptionLoader(): JSX.Element {
	return (
		<LazyComponent
			loadComponent={loadDescriptionStep}
			fallback={
				<Box margin="auto">
					<Loader />
				</Box>
			}
		/>
	);
}

export const preloadDescriptionStep = loadDescriptionStep;
